import React from 'react';
import { PrinterIcon, LayersIcon, Gamepad2Icon, ZapIcon, StarIcon, MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: PrinterIcon,
  label: '100% IMPRIMIBLE'
}, {
  icon: LayersIcon,
  label: 'ACTIVIDADES A Y B'
}, {
  icon: Gamepad2Icon,
  label: 'JUEGOS E HISTORIETAS'
}, {
  icon: ZapIcon,
  label: 'ACCESO INMEDIATO'
}];
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  location: 'Bogotá, Colombia',
  specialty: 'Educación secundaria',
  quote: '"Organicé todo el año en una tarde"',
  color: 'bg-chem-petrol'
}, {
  initials: 'MG',
  name: 'Martín G.',
  location: 'Lima, Perú',
  specialty: 'Educación secundaria',
  quote: '"Mis clases de Química por fin enganchan"',
  color: 'bg-chem-electric'
}, {
  initials: 'LG',
  name: 'Laura G.',
  location: 'Santiago, Chile',
  specialty: 'Educación secundaria',
  quote: '"Nunca más improvisé una evaluación"',
  color: 'bg-chem-turquoise'
}];
export function SocialProof() {
  return <section className="py-4 md:py-8 px-4 max-w-7xl mx-auto -mt-4 md:-mt-12 relative z-10" data-id="element-246" data-mp="1pbt79xz09mvm">
      <ul className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-247" data-mp="23zwbb1thmohs">
        {benefits.map((benefit, index) => {
        const Icon = benefit.icon;
        return <motion.li key={benefit.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className="bg-white border border-chem-petrol/12 rounded-2xl px-3 py-4 md:px-5 md:py-6 flex flex-col items-center text-center gap-2 shadow-sm" data-id="element-248" data-mp="2czt67l6h0jla" data-mpi={index}>
              <span className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl bg-chem-ice text-chem-petrol" data-id="element-249" data-mp="slitadlf139o">
                <Icon className="w-5 h-5 md:w-6 md:h-6" strokeWidth={2.2} data-id="element-250" data-mp="nnhc5y7jve0u" />
              </span>
              <span className="text-chem-navy font-black text-[10px] md:text-sm uppercase tracking-wide leading-tight" data-id="element-251" data-mp="1dbd2398k2p9g">
                {benefit.label}
              </span>
            </motion.li>;
      })}
      </ul>

      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-252" data-mp="1r9bck3jra1jo">
        {testimonials.map((t, index) => <motion.div key={t.name} initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1 + 0.3
      }} className="bg-white p-6 md:p-8 rounded-3xl shadow-xl shadow-chem-navy/5 border border-chem-petrol/10 flex flex-col" data-id="element-253" data-mp="1w8nx2hn5mwj3" data-mpi={index}>
            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-254" data-mp="2a1name3dmgo0">
              <div className={`${t.color} w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl flex items-center justify-center text-white font-black text-base md:text-lg shadow-lg`} data-id="element-255" data-mp="2f0qjk9mh9719">
                {t.initials}
              </div>
              <div data-id="element-256" data-mp="3baikjkchzvv">
                <div className="flex gap-0.5 mb-1" data-id="element-257" data-mp="3aqyoxb4x1f7">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 fill-chem-amber text-chem-amber" data-id="element-258" data-mp="3uidaxebx6c7o" data-mpi={i} />)}
                </div>
                <p className="text-xs font-bold text-chem-navy/45 uppercase tracking-tighter" data-id="element-259" data-mp="r0ld3jb3qy1k">
                  Verificado
                </p>
              </div>
            </div>
            <blockquote className="text-base md:text-lg font-bold text-chem-navy mb-4 md:mb-6 leading-tight flex-1" data-id="element-260" data-mp="ha9xv0lyx2fd">
              {t.quote}
            </blockquote>
            <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-chem-ice mt-auto" data-id="element-261" data-mp="19rmcu9k1qxm6">
              <div className="text-xs md:text-sm" data-id="element-262" data-mp="150e0p5rc0y5b">
                <p className="font-black text-chem-navy" data-id="element-263" data-mp="14zl3owi6dn0d">{t.name}</p>
                <div className="flex items-center gap-1 text-chem-navy/55 font-medium" data-id="element-264" data-mp="phutuf2ioo1i">
                  <MapPinIcon size={12} data-id="element-265" data-mp="ui93u2noi826" />
                  <span data-id="element-266" data-mp="ujaieh3wlcon">
                    {t.location} | {t.specialty}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}